import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { SettingsDialog } from "@/components/SettingsDialog";
import { Settings, Sparkles } from "lucide-react";

export const Header = () => {
  const { t, lang, setLang } = useApp();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const loc = useLocation();

  const navItem = (to, label, id) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={id}
        className={`px-3 py-1.5 rounded-md text-sm font-bold font-display transition-colors ${
          active ? "bg-ink text-cream" : "text-ink hover:bg-black/5"
        }`}
      >
        {label}
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-40 border-b-2 border-ink bg-cream/90 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 min-w-0">
          <span className="grid place-items-center w-9 h-9 rounded-md bg-coral border-2 border-ink shadow-brutal-sm shrink-0">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black text-base sm:text-lg tracking-tight truncate">
            {t("brand")}
          </span>
        </Link>

        <div className="flex items-center gap-1.5 sm:gap-2">
          <nav className="hidden sm:flex items-center gap-1 mr-1">
            {navItem("/", t("nav_home"), "nav-home")}
            {navItem("/stats", t("nav_stats"), "nav-stats")}
          </nav>

          <button
            data-testid="lang-toggle-btn"
            onClick={() => setLang(lang === "tr" ? "en" : "tr")}
            className="px-2.5 py-1.5 rounded-md border-2 border-ink bg-white text-ink text-xs font-black font-display shadow-brutal-sm hover:-translate-y-0.5 transition-transform"
          >
            {lang === "tr" ? "TR" : "EN"}
          </button>

          <button
            data-testid="settings-btn"
            onClick={() => setSettingsOpen(true)}
            aria-label={t("settings")}
            className="grid place-items-center w-9 h-9 rounded-md border-2 border-ink bg-white shadow-brutal-sm hover:-translate-y-0.5 transition-transform"
          >
            <Settings className="w-4 h-4" strokeWidth={2.5} />
          </button>
        </div>
      </div>
      <SettingsDialog open={settingsOpen} onOpenChange={setSettingsOpen} />
    </header>
  );
};
